import React, { useEffect, useState } from "react";

import useStore, { loadingListSelector } from "../../store";
import { SrOnly } from "../styles";
interface LoadingAnnouncerProps {
	loadingMessage?: string;
	completedMessage?: string;
}

const LoadingAnnouncer: React.FC<LoadingAnnouncerProps> = ({ loadingMessage, completedMessage }) => {
	const loadingList = useStore(loadingListSelector);
	const [message, setMessage] = useState<string | null>(null);

	useEffect(() => {
		let timer: ReturnType<typeof setTimeout> | undefined;

		if (loadingList.length === 0) {
			const msg = completedMessage || "Page Loaded";
			setMessage(msg);

			timer = setTimeout(() => setMessage(null), 800);
		} else {
			const msg = loadingMessage || "Page Loading";
			setMessage(msg);
		}

		return () => {
			if (timer) clearTimeout(timer);
		};
	}, [completedMessage, loadingList, loadingMessage]);

	if (!message) return null;

	return (
		<SrOnly role="status" aria-live="polite" aria-atomic="true">
			{message}
		</SrOnly>
	);
};

export default LoadingAnnouncer;
